export default __webpack_public_path__ + "static/ADOT-log-event-05095d3464c3e0daedc16296b4155073.png";